import { Pipe, PipeTransform } from '@angular/core';
import * as markdownItModule from 'markdown-it';

type TMarkdownItConstructor = new (options?: { html?: boolean; linkify?: boolean; breaks?: boolean }) => {
  render(source: string): string;
};

// markdown-it's CommonJS entry is `module.exports = MarkdownIt`. esbuild exposes the constructor
// on `.default`, while Jest's transform binds the raw `require()` result (the constructor itself)
// — so resolve `.default` first and fall back to the module. A bare default import resolves to
// `undefined` in Jest because the workspace tsconfig has no `esModuleInterop`.
const MarkdownIt =
  (markdownItModule as unknown as { default?: TMarkdownItConstructor }).default ??
  (markdownItModule as unknown as TMarkdownItConstructor);

// `html: false` escapes any raw HTML in the source, so the rendered string only contains
// markdown-generated tags; Angular additionally sanitises it when bound via `[innerHTML]`.
const markdownIt = new MarkdownIt({ html: false, linkify: true, breaks: true });

@Pipe({ name: 'markdown' })
export class MarkdownPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value ? markdownIt.render(value) : '';
  }
}
